import { Component, Input, TemplateRef, ViewEncapsulation } from '@angular/core';

import { ActionMenuComponent } from '../action-menu/action-menu.component';

@Component({
  selector: 'lib-floating-action-fab',
  standalone: true,
  imports: [ActionMenuComponent],
  encapsulation: ViewEncapsulation.None,
  template: `
    <div class="floating-action-fab">
      <lib-action-menu
        [menuTemplate]="menuTemplate"
        [buttonAriaLabel]="buttonAriaLabel"
        [disabled]="disabled"
        align="end"
        direction="up"
      />
    </div>
  `,
  styles: [`
    .floating-action-fab {
      position: fixed;
      right: 20px;
      bottom: 20px;
      z-index: 25;
      display: block;
    }

    @media (max-width: 640px) {
      .floating-action-fab {
        right: 16px;
        bottom: 16px;
      }
    }
  `],
})
export class FloatingActionFabComponent {
  @Input({ required: true }) public menuTemplate!: TemplateRef<{ close: () => void }>;
  @Input() public buttonAriaLabel = 'Open quick actions';
  @Input() public disabled = false;
}
